// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cases-tab-main {
  display: flex;
  justify-content: space-between;
}

.court-tabs-container .court-tabs {
  display: flex;
  gap: 2px;
  background-color: #E2E8F0;
  padding: 4px;
  border-radius: 8px;
  width: fit-content;
}
.court-tabs-container .court-tabs button {
  padding: 8px 18px;
  border: none;
  background: transparent;
  color: #64748b;
  font-weight: 500;
  font-size: 14px;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: flex-start;
}
.court-tabs-container .court-tabs button:hover {
  background: rgba(255, 255, 255, 0.8);
  color: #374151;
}
.court-tabs-container .court-tabs button.active {
  background: #ffffff;
  color: #1f2937;
  font-weight: 600;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}
.court-tabs-container .court-tabs button .court-badge {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: crimson;
  color: white;
  font-size: 10px;
  font-weight: bold;
  border-radius: 50%;
  width: 17px;
  height: 17px;
  margin-left: 8px;
  animation: popIn 0.3s ease-in-out;
}
@keyframes popIn {
  0% {
    transform: scale(0.5);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

.case-tabs-container .case-tabs {
  display: flex;
  gap: 2px;
  background: #E2E8F0;
  padding: 4px;
  border-radius: 8px;
  width: fit-content;
}
.case-tabs-container .case-tabs button {
  padding: 8px 18px;
  border: none;
  background: transparent;
  color: #6b7280;
  font-weight: 500;
  font-size: 13px;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
}
.case-tabs-container .case-tabs button:hover {
  background: rgba(255, 255, 255, 0.8);
  color: #374151;
}
.case-tabs-container .case-tabs button.active {
  background: #ffffff;
  color: #1f2937;
  font-weight: 600;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

@media (max-width: 768px) {
  .cases-container {
    padding: 1rem;
  }
  .court-tabs-container .court-tabs,
  .case-tabs-container .case-tabs {
    width: 100%;
  }
  .court-tabs-container .court-tabs button,
  .case-tabs-container .case-tabs button {
    flex: 1 1;
    text-align: center;
  }
}
@media (max-width: 480px) {
  .court-tabs-container .court-tabs button {
    padding: 8px 12px;
    font-size: 12px;
  }
  .case-tabs-container .case-tabs button {
    padding: 6px 10px;
    font-size: 11px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Cases/Cases.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,8BAAA;AACF;;AAIE;EACE,aAAA;EACA,QAAA;EACA,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;AADJ;AAGI;EACE,iBAAA;EACA,YAAA;EACA,uBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,aAAA;EACA,uBAAA;AADN;AAGM;EACE,oCAAA;EACA,cAAA;AADR;AAIM;EACE,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,wCAAA;AAFR;AAKM;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,iCAAA;AAHR;AAMM;EACE;IACE,qBAAA;IACA,UAAA;EAJR;EAOM;IACE,mBAAA;IACA,UAAA;EALR;AACF;;AAcE;EACE,aAAA;EACA,QAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;AAXJ;AAaI;EACE,iBAAA;EACA,YAAA;EACA,uBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;AAXN;AAaM;EACE,oCAAA;EACA,cAAA;AAXR;AAcM;EACE,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,wCAAA;AAZR;;AAmBA;EACE;IACE,aAAA;EAhBF;EAmBA;;IAEE,WAAA;EAjBF;EAmBE;;IACE,SAAA;IACA,kBAAA;EAhBJ;AACF;AAoBA;EACE;IACE,iBAAA;IACA,eAAA;EAlBF;EAqBA;IACE,iBAAA;IACA,eAAA;EAnBF;AACF","sourcesContent":[".cases-tab-main {\n  display: flex;\n  justify-content: space-between;\n}\n\n.court-tabs-container {\n\n  .court-tabs {\n    display: flex;\n    gap: 2px;\n    background-color: #E2E8F0;\n    padding: 4px;\n    border-radius: 8px;\n    width: fit-content;\n\n    button {\n      padding: 8px 18px;\n      border: none;\n      background: transparent;\n      color: #64748b;\n      font-weight: 500;\n      font-size: 14px;\n      border-radius: 6px;\n      cursor: pointer;\n      transition: all 0.2s ease;\n      display: flex;\n      align-items: flex-start;\n\n      &:hover {\n        background: rgba(255, 255, 255, 0.8);\n        color: #374151;\n      }\n\n      &.active {\n        background: #ffffff;\n        color: #1f2937;\n        font-weight: 600;\n        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n      }\n\n      .court-badge {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        background-color: crimson;\n        color: white;\n        font-size: 10px;\n        font-weight: bold;\n        border-radius: 50%;\n        width: 17px;\n        height: 17px;\n        margin-left: 8px;\n        animation: popIn 0.3s ease-in-out;\n      }\n\n      @keyframes popIn {\n        0% {\n          transform: scale(0.5);\n          opacity: 0;\n        }\n\n        100% {\n          transform: scale(1);\n          opacity: 1;\n        }\n      }\n\n    }\n  }\n}\n\n.case-tabs-container {\n\n  .case-tabs {\n    display: flex;\n    gap: 2px;\n    background: #E2E8F0;\n    padding: 4px;\n    border-radius: 8px;\n    width: fit-content;\n\n    button {\n      padding: 8px 18px;\n      border: none;\n      background: transparent;\n      color: #6b7280;\n      font-weight: 500;\n      font-size: 13px;\n      border-radius: 6px;\n      cursor: pointer;\n      transition: all 0.2s ease;\n\n      &:hover {\n        background: rgba(255, 255, 255, 0.8);\n        color: #374151;\n      }\n\n      &.active {\n        background: #ffffff;\n        color: #1f2937;\n        font-weight: 600;\n        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n      }\n    }\n  }\n}\n\n// Responsive Design\n@media (max-width: 768px) {\n  .cases-container {\n    padding: 1rem;\n  }\n\n  .court-tabs-container .court-tabs,\n  .case-tabs-container .case-tabs {\n    width: 100%;\n\n    button {\n      flex: 1;\n      text-align: center;\n    }\n  }\n}\n\n@media (max-width: 480px) {\n  .court-tabs-container .court-tabs button {\n    padding: 8px 12px;\n    font-size: 12px;\n  }\n\n  .case-tabs-container .case-tabs button {\n    padding: 6px 10px;\n    font-size: 11px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
